import { withPermissionGuard } from '@libs/permission'
import { CampaignDetailPage } from './CampaignDetailPage'
import { withCampaignDetailPage } from './withCampaignDetailPage'

const Connected = withPermissionGuard(
  withCampaignDetailPage(CampaignDetailPage),
  'promotionCampaign',
  'view'
)

export { Connected as CampaignDetailPage }
